import { useTranslation } from 'react-i18next';
import useAppUser from 'hooks/useAppUser';
import useNotify from 'hooks/useNotify';
import useRequestPremiumDbsEditorLink from 'pages/agencySettings/dbs/useRequestPremiumDbsEditorLink';

export const PREMIUM_DBS_EDITOR_WINDOW_NAME = 'hf-premium-dbs-editor';

const useOpenPremiumDbsEditor = () => {
  const { t } = useTranslation();
  const { agencyUid, user } = useAppUser();
  const { notifyError } = useNotify();
  const { mutateAsync: requestEditorLink, isLoading } =
    useRequestPremiumDbsEditorLink();

  const openPremiumDbsEditor = async () => {
    // The window has to be opened from inside the click handler or the popup blocker kills
    // it, so it starts blank and receives the SSO url once the request comes back.
    const editorWindow = window.open(
      'about:blank',
      PREMIUM_DBS_EDITOR_WINDOW_NAME,
    );

    try {
      const {
        data: { ssoUrl },
      } = await requestEditorLink({
        agencyUid: agencyUid!,
        employeeEmail: user?.email,
        employeeFirstName: user?.firstName,
        employeeLastName: user?.lastName,
      });

      if (!ssoUrl) {
        throw new Error('The editor access response carried no sso url');
      }

      if (editorWindow) {
        editorWindow.location.href = ssoUrl;
      }
    } catch (error) {
      editorWindow?.close();
      notifyError(t('pageDirectBookingEngine.siteAccess.editorError'));
    }
  };

  return { openPremiumDbsEditor, isOpeningEditor: isLoading };
};

export default useOpenPremiumDbsEditor;
